import React from "react";
import TextInfo from "@/bit/components/components.text";
import StoreLink from "./store-link";

const Title = (props) => {
  if (props && props["Text-1"]) {
    return (
      <>
        <div className="container device-services--title">
          <TextInfo {...props["Text-1"]} />
          {props["CustomLink-1"] && (
            <StoreLink infolink={props["CustomLink-1"]} />
          )}
        </div>

        <style jsx>
          {`
            .device-services--title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-flow: row nowrap;
              align-items: center;
              gap: 0.375rem;
            }           
          `}
        </style>
      </>
    );
  }
  return null;
};

export default Title;
